import { render, staticRenderFns } from "./Lrypz.vue?vue&type=template&id=2ccb2c82&scoped=true&"
import script from "./Lrypz.vue?vue&type=script&lang=js&"
export * from "./Lrypz.vue?vue&type=script&lang=js&"
import style0 from "./Lrypz.vue?vue&type=style&index=0&id=2ccb2c82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccb2c82",
  null
  
)

export default component.exports